import { render, staticRenderFns } from "./ProductModificationView.vue?vue&type=template&id=0cf45d82&"
import script from "./ProductModificationView.vue?vue&type=script&lang=js&"
export * from "./ProductModificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports